module.exports = __webpack_public_path__ + "42295bf4df9215298de6b4e55fde2751.MP3";